import Globals from "../../globals.ts";
import Rex from "../../entities/rex.ts";
import Chip from "../../entities/chip.ts";
import Trap from "./trap.ts";
/**
 * ElectricityBarrier is a trap that damages Rex when he collides with it,
 * but allows Chip to pass through and recharges Chip's battery.
 */
class ElectricityBarrier extends Trap {
    /**
     * Constructor for ElectricityBarrier.
     * @param pos - The position of the barrier.
     * @param tileIndex - The tile index for visual representation.
     */
    constructor(pos, tileIndex) {
        super(pos, tileIndex);
        this.mass = 0; // Not affected by gravity
    }
    /**
     * Updates the ElectricityBarrier behavior.
     * Damages Rex if close, recharges Chip's battery if close.
     */
    update() {
        const distance = this.pos.distance(Globals.player.pos);
        if (distance < this.distance) {
            if (Globals.player instanceof Rex) {
                Globals.player?.takeDamage(this.damage, this.pos.copy());
            }
            else if (Globals.player instanceof Chip) {
                // Recharge Chip's battery
                Globals.player.battery = Math.min(100, Globals.player.battery + 0.5);
            }
        }
    }
    /**
     * Handles collision with other objects.
     * Blocks Rex from passing through, allows Chip to pass through.
     * @param other - The other object colliding with this barrier.
     * @returns true if collision should occur (block), false otherwise.
     */
    collideWithObject(other) {
        if (other instanceof Rex) {
            return true; // Block Rex
        }
        else if (other instanceof Chip) {
            return false; // Allow Chip to pass through
        }
        return false; // Default: allow other objects to pass
    }
}
export default ElectricityBarrier;
